import React, {Component} from 'react'
import axios from 'axios'
import Modal from "react-bootstrap/Modal";
import Loader from 'react-loader-spinner';
import DateRange from '../../../../commons/components/DateRange'
import Pagination from '../../../../commons/components/Paginations'
import CS from '../../../../commons/services/Common'
import FS from '../../../../commons/services/Format'
import MS from '../../../../commons/services/Moment'
import AS from '../../../Login/Service/Authentication'
import PS from '../../../PlantList/MonitoringApiService'
import { withTranslation } from 'react-i18next';

/**
 * 전체 발전소 목록 컴포넌트
 */
class Stat extends Component {
    

    constructor(props) {
        super(props);
        this.state = {
            plantId: props.match.params.plantId,
            isLoading: true,
            sInverterSerialNos: [],
            inverterSerialNos: [],
            isModalOpen: false,
            fromDate: MS.format(new Date(), 'YYYY-MM-DD'),
            toDate: MS.format(new Date(), 'YYYY-MM-DD'),
            items: [],
            item: {},
            totalCount: 0,
            addTag: [],
        }
    }

    componentDidMount() {
        this.getPlantInfo();
    }

    async getPlantInfo() {
        const {plantId, inverterSerialNos} = this.state;
        if (inverterSerialNos.length == 0) {
            const res = await axios.get(`/usr/api/user-plant/info?plantIds=${plantId}`);
            this.setState({
                info: res.data[0],
            });
            const plantInfos = AS.getLoggedInPlantInfos();
            let filteredPlantInfo = plantInfos.filter(v => v.id == plantId);
            let inverterSerialNos = CS.getKeyValues(filteredPlantInfo[0].invs, "serialNo");
            this.setState({
                inverterSerialNos: inverterSerialNos,
                sInverterSerialNos: inverterSerialNos
            });
            this.getData(inverterSerialNos);
        } else {
            this.getData(inverterSerialNos);
        }
    }

    getData = async(sSerialNos) => {
        await this.setState({
            addTag: [],
            items: [],
            isLoading: true
        });
        const {fromDate, toDate} = this.state;
        const res = await this.getInverterList(sSerialNos, fromDate, toDate);
        this.setState({
            items: res,
            totalCount: res.length,
            isLoading: false
        });
    }

    getInverterList = async(inverterSerialNos, fromDate, toDate) => {
        const stats = await PS.getStatInverterList({
            "inverterSerialNos": inverterSerialNos,
            "fromDate": fromDate,
            "toDate": toDate
        });
        stats.map(v => v.isEditMode = false);
        return stats;
    }

    handleDateChange = async (ranges) => {
        await this.setState({
            fromDate: ranges[0],
            toDate: ranges[1] ,
        });
        this.getData(this.state.sInverterSerialNos);
    }

    handleInverterChange = async() => {
        let serialNo = document.getElementById("serialNo").value;
        let sSerialNos;
        if (serialNo) {
            sSerialNos = new Array(serialNo);
        } else {
            sSerialNos = this.state.inverterSerialNos
        }
        this.setState({
            sInverterSerialNos: sSerialNos
        })
        this.getData(sSerialNos);
    }

    handleEdit = (id) => {
        const {items} = this.state;
        const index = items.findIndex((e, index, array) => {
            return e.id === id;
        });
        items[index].isEditMode = true;
        this.setState({
            items: items,
        });
    }

    handleInputChange = (e, index) => {
        const {items} = this.state;
        const name = e.target.name;
        let value = e.target.value;
        if (name === 'power') {
            value = Number(FS.fmtNumber(value));
        }
        items[index][name] = value;
        this.setState({
            items: items
        });
    }

    handleAdd = () => {
        const {addTag, inverterSerialNos} = this.state;
        const { t } = this.props;
        if (addTag.length > 0) {
            alert(t("key554")); // 새로 추가할 정보를 입력하고 저장하세요.
            return;
        }
        let tag = [];

        tag.push(
            <tr>
                <td></td>
                <td>
                    {
                        inverterSerialNos.length == 1
                        ?   <input type="text" className="w120" id="newSerialNo" value={inverterSerialNos[0]} readOnly /> 
                        :   <select id="newSerialNo">
                            {
                                inverterSerialNos.map((row, index) => (
                                    <option key={index} value={row}>{row}</option>
                                ))
                            }
                            </select>
                    }
                </td>
                <td><input type="text" className="w120" id="newYmd" placeholder="날짜" maxLength="8" onChange={(e) => this.handleAddChange(e, 'ymd')} /></td>
                <td>
                    <select id="newHh">
                    {
                        Array(24).fill(1).map((el, i) =>
                            <option key={i} value={CS.fillZero(2, i.toString())}>{i}시</option>
                        )
                    }
                    </select>
                </td>
                <td><input type="text" className="w80" id="newPower"  placeholder="발전량" maxLength="6" onChange={(e) => this.handleAddChange(e, 'power')} /></td>
                <td><button type="button" className="btn sm blue" onClick={this.handleSave}>저장</button></td>
            </tr>
        );
        this.setState({
            addTag: tag
        });
    }

    handleAddChange = (e, type) => {
        let isOk = true;
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        if (type === "ymd") {
            value = value.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
        }
        e.target.value= value;
    }

    handleSave = async() => {
        const { t } = this.props;
        const item = {
            serialNo: CS.$("#newSerialNo"),
            ymd: CS.$("#newYmd"),
            hh: CS.$("#newHh"),
            power: Number(CS.$("#newPower"))
        };
        const isValidDate = MS.isValidDate(item.ymd, 'YYYY-MM-DD');
        if (isValidDate) {
            item.y = item.ymd.substring(0, 4);
            item.ym = item.ymd.substring(0, 7);
            item.quarter = MS.getQuarter(item.ymd).toString();
        } else {
            alert(t("key555")); // 날짜를 올바르게 입력하세요.
            return;
        }

        if (!item.power) {
            if (item.power !== 0) {
                alert(t("key556")); // 발전량을 입력하세요.
                return;
            }
        }
        const isConfirm = window.confirm(t("key557")); // 추가 하시겠습니까?
        if (isConfirm) {
            let res = await PS.createStatInverter(item);
            if (res) {
                CS.notification("success", t("key558")); // 정상적으로 추가 되었습니다.
                this.getData(this.state.sInverterSerialNos);
            } else {
                CS.notification("error", t("key559")); // 이미 존재하는 데이터 입니다.
            }
            
        }
    }

    
    handleUpdate = async (index) => {
        const {items} = this.state;
        const { t } = this.props;
        let isSuccess = false;
        const isConfirm = window.confirm(t("key560")); // 수정 하시겠습니까?
        if (isConfirm) {
            let res = await PS.updateStatInverter(items[index]);
            if (res) {
                CS.notification("success", t("key561")); // 수정 되었습니다.
                items.map(v => {return v.isEditMode = false});
            }
        } else {
            items[index].isEditMode = false;
        }
        this.setState({
            items: items
        });
    }

    handleDelete = async(id) => {
        const { t } = this.props;
        const isConfirm = window.confirm(t("key562")); // 삭제 하시겠습니까?
        const item = {
            id: id
        };
        if (isConfirm) {
            await PS.deleteStatInverter(item);
            CS.notification("success", t("key563")); // 삭제 되었습니다.
            this.getData(this.state.sInverterSerialNos);
        }
    }

    render() {
        const { isLoading, items, item, totalCount, inverterSerialNos, isModalOpen, addTag } = this.state;
        const { t } = this.props;
        return (
            <>
                <div className="page-tit gray">
                    <div className="container f-stack">
                        <h2 className="tit">{t('key395')}</h2>
                    </div>
                </div>
                <div className="container">
                    <div className="top-search">
                        <div className="txt"><strong>{t('key396')}</strong> {t('key397')} {totalCount}{t('key398')}</div>
                        
                        <div className="search">
                            <form onSubmit={e => e.preventDefault()}>
                                <DateRange handleDateChange={this.handleDateChange} />&nbsp;
                                {
                                    inverterSerialNos.length > 1 &&
                                    <select id="serialNo" title="정렬선택" onChange={this.handleInverterChange}>
                                        <option value="">{t("key565")}</option>
                                        {
                                            inverterSerialNos.map((row, index) => (
                                                <option key={index} value={row}>{`${t("key564")}${index+1}`}</option>
                                            ))
                                        }
                                    </select>
                                }
                                <div className="f-stack mb-10" style={{float: "right"}}>
                                    <button className="btn sm green w60" onClick={this.handleAdd}>{t('key400')}</button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="table-wrapper">
                        <table className="h-table">
                            <colgroup>
                                <col style={{width: "10%"}}/>
                                <col />
                                <col style={{width: "15%"}}/>
                                <col style={{width: "10%"}}/>
                                <col style={{width: "10%"}}/>
                                <col style={{width: "15%"}}/>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{t('key401')}</th>
                                    <th>{t('key402')}</th>
                                    <th>{t('key403')}</th>
                                    <th>{t('key404')}</th>
                                    <th>{t('key405')}</th>
                                    <th>{t('key406')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {addTag}
                                {
                                    isLoading
                                    ?   <tr><td colSpan="6"><Loader type="ThreeDots" color="#211b41" height="25" width="25" /></td></tr>
                                    :   items.length > 0
                                        ?
                                            items.map((row, index) => (
                                                <tr key={row.id}>
                                                    <td>
                                                        <label className="num">
                                                            { index + 1 }
                                                        </label>
                                                    </td>
                                                    {
                                                        row.isEditMode == undefined || !row.isEditMode
                                                        ?   <>
                                                            <td>{row.serialNo}</td>
                                                            <td>{row.ymd}</td>
                                                            <td>{row.hh}시</td>
                                                            <td>{CS.setComma(row.power)}</td>
                                                            <td>
                                                                <a onClick={() => this.handleEdit(row.id)} className="circle-btn">
                                                                    <i className="material-icons">edit</i>
                                                                </a>
                                                            </td>
                                                            </>
                                                        :   <>
                                                            <td>{row.serialNo}</td>
                                                            <td>{row.ymd}</td>
                                                            <td>{row.hh}시</td>
                                                            <td><input type="text" className="w80" name="power" value={row.power} onChange={(e) => this.handleInputChange(e, index)}/></td>
                                                            <td>
                                                                <button type="button" className="btn sm blue" onClick={()=>this.handleUpdate(index)}>{t('key297')}</button>
                                                                <button type="button" className="btn sm red" onClick={()=>this.handleDelete(row.id)}>{t('key379')}</button>
                                                            </td>
                                                            </>
                                                    }
                                                </tr>
                                            ))
                                            :
                                            <tr>
                                                <td colSpan="6">{t('key408')}</td>
                                            </tr>
                                    
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        <div className="paging-wrap">
                            <Pagination handlePagingChange={this.getItems} count={this.state.pageSize} />
                        </div>
                    }
                    
                </div>

                <DetailModal show={isModalOpen} item={item} closeModal={() => this.setState({isModalOpen: false})} t={t}/>
            </>
        )
    }
}


class DetailModal extends React.Component {
    render() {
        const {show, item, closeModal, t} = this.props;
        return (
            <>
            <Modal show={show} size="lg" centered>
                <Modal.Body>
                    <div className="modal-header">
                        <button type="button" className="close" onClick={closeModal}><span aria-hidden="true">&times;</span></button>
                        <h4 className="modal-title">{t("key567")}</h4>
                    </div>
                    <div className="modal-body">
                        {
                            !CS.checkIsEmptyObject(item) &&
                            <div className="p-body">
                                <table className="v-table">
                                    <colgroup>
                                        <col style={{width: "15%"}}/>
                                        <col />
                                        <col style={{width: "15%"}}/>
                                        <col style={{width: "18%"}}/>
                                        <col style={{width: "15%"}}/>
                                        <col style={{width: "18%"}}/>
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>{t("key568")}</th>
                                            <td><b>{item.time}</b></td>
                                            <th>{t('key569')}</th>
                                            <td>{item.power}</td>
                                            <th>{t('key570')}</th>
                                            <td>{CS.setComma(item.accumulationPower)}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('key483')}</th>
                                            <td>{item.pvVolt}</td>
                                            <th>{t('key484')}</th>
                                            <td>{item.pvCurrent}</td>
                                            <th>{t('key550')}</th>
                                            <td>{item.pvCurrent}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('key485')}</th>
                                            <td>{item.lineRVolt}</td>
                                            <th>{t('key487')}</th>
                                            <td>{item.lineSVolt}</td>
                                            <th>{t('key489')}</th>
                                            <td>{item.lineTVolt}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('key486')}</th>
                                            <td>{item.lineRCurrent}</td>
                                            <th>{t('key488')}</th>
                                            <td>{item.lineSCurrent}</td>
                                            <th>{t('key490')}</th>
                                            <td>{item.lineTCurrent}</td>
                                        </tr>
                                        <tr>
                                            <th>{t('key285')}</th>
                                            <td>{item.temperature}</td>
                                            <th>{t('key571')}</th>
                                            <td>{item.hertz}</td>
                                            <th>{t('key572')}</th>
                                            <td>{item.runStatus}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                        
                    <div className="modal-footer2">
                        <button type="button" className="btn blue" onClick={() => this.controlIdChangeModal(show)}>{t('key61')}</button>
                        <button type="button" className="btn red" onClick={closeModal}>{t('key447')}</button>
                    </div>
                </Modal.Body>
            </Modal>
            
            </>
        );
    }
}

export default withTranslation()(Stat)
